import apiClient from '../utils/apiClient';
import { ProfileSummary, ProfileDetail } from '../types/profile';

export const profileService = {
  // Read operations
  async fetchProfilesList(): Promise<{ profiles: ProfileSummary[] }> {
    const response = await apiClient.get('/api/config/profiles');
    return response.data;
  },

  async fetchProfile(profileId: string): Promise<ProfileDetail> {
    const response = await apiClient.get(`/api/config/profiles/${profileId}`);
    return response.data;
  },

  // Field CRUD
  async createField(profileId: string, fieldData: Record<string, any>): Promise<Record<string, any>> {
    const response = await apiClient.post(`/api/config/profiles/${profileId}/fields`, fieldData);
    return response.data;
  },

  async updateField(profileId: string, fieldId: string, fieldData: Record<string, any>): Promise<Record<string, any>> {
    const response = await apiClient.put(`/api/config/profiles/${profileId}/fields/${fieldId}`, fieldData);
    return response.data;
  },

  async deleteField(profileId: string, fieldId: string): Promise<void> {
    await apiClient.delete(`/api/config/profiles/${profileId}/fields/${fieldId}`);
  },

  // Agent CRUD
  async createAgent(profileId: string, agentData: Record<string, any>): Promise<Record<string, any>> {
    const response = await apiClient.post(`/api/config/profiles/${profileId}/agents`, agentData);
    return response.data;
  },

  async updateAgent(profileId: string, agentId: string, agentData: Record<string, any>): Promise<Record<string, any>> {
    const response = await apiClient.put(`/api/config/profiles/${profileId}/agents/${agentId}`, agentData);
    return response.data;
  },

  async deleteAgent(profileId: string, agentId: string): Promise<void> {
    await apiClient.delete(`/api/config/profiles/${profileId}/agents/${agentId}`);
  },

  // Seed profile from hardcoded data
  async seedProfile(profileId: string): Promise<{ message: string }> {
    const response = await apiClient.post(`/api/config/profiles/${profileId}/seed`);
    return response.data;
  },
};
